/* Caster Central 2026-10-25: native review scroller for snippets/review-carousel.liquid.
   Replaces Flickity on the review carousel. Flickity's init restructures the track and Chrome
   scored it as a 0.316 layout shift on every desktop homepage load (PageSpeed, CrUX), wherever
   the carousel sat on the page. The track is a CSS scroll-snap row; this file only adds the
   arrows, arrow keys and a gentle autoplay. Scrolling is never a layout shift. */
(function () {
  function init(track) {
    if (track.__ccReviews) return;
    track.__ccReviews = true;
    var frame = track.closest('.review-carousel__frame') || track.parentElement;
    var prev = frame.querySelector('[data-cc-review-prev]');
    var next = frame.querySelector('[data-cc-review-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var how = reduce ? 'auto' : 'smooth';

    function step() {
      var card = track.querySelector('.review-carousel__card');
      if (!card) return track.clientWidth;
      var s = getComputedStyle(card);
      var w = card.getBoundingClientRect().width + parseFloat(s.marginLeft) + parseFloat(s.marginRight);
      return Math.max(w, Math.floor((track.clientWidth + 1) / w) * w);
    }
    function go(dir) {
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dir > 0 && end) track.scrollTo({ left: 0, behavior: how });
      else if (dir < 0 && track.scrollLeft <= 4) track.scrollTo({ left: track.scrollWidth, behavior: how });
      else track.scrollBy({ left: dir * step(), behavior: how });
    }

    var ms = parseInt(track.getAttribute('data-autoplay'), 10) || 0;
    var stopped = reduce || ms <= 0, visible = false, hover = false, timer = null;
    function stop() { stopped = true; if (timer) clearInterval(timer); timer = null; }

    if (prev) prev.addEventListener('click', function () { stop(); go(-1); });
    if (next) next.addEventListener('click', function () { stop(); go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(-1); }
    });

    if (!stopped) {
      ['pointerdown', 'touchstart'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
      frame.addEventListener('mouseenter', function () { hover = true; });
      frame.addEventListener('mouseleave', function () { hover = false; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.5 }).observe(track);
      } else {
        visible = true;
      }
      timer = setInterval(function () {
        if (!stopped && visible && !hover && !document.hidden && !frame.contains(document.activeElement)) go(1);
      }, ms);
    }
  }
  function boot() { document.querySelectorAll('[data-cc-review-scroller]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
